export default __webpack_public_path__ + "static/media/rounded-challenges.a2f2db11.svg";